import { Outlet, useLocation } from "react-router-dom";
import { useCase } from "../../context/CaseContext";
import { PrerequisiteChecklist } from "./PrerequisiteChecklist";
import { ShownResults } from "./ShownResults";

/** What stays on the litigation path whatever is shown elsewhere. */
const LITIGATION_ONLY = /\/analytics\/(reserve|bargaining|tree)$/;

/**
 * Sits on the `analytics` route so one check covers every view beneath it;
 * the individual views therefore carry no "not enough data" guard of their own.
 *
 * The server declines to calculate a case whose configuration is incomplete, so
 * without this the views would each fall back to their own "no data" message —
 * accurate but unhelpful, and silent about which of five things is missing.
 *
 * The fee structure is deliberately not part of this check: it bears only on
 * revenue, and RevenueAnalytics adds that row itself.
 */
export const AnalyticsGate = () => {
  const caseContext = useCase();
  const c = caseContext.getCase();
  const prerequisites = caseContext.getPrerequisites();
  const { pathname } = useLocation();

  if (prerequisites.every(({ met }) => met))
    return LITIGATION_ONLY.test(pathname) ? (
      <Outlet />
    ) : (
      <ShownResults>
        <Outlet />
      </ShownResults>
    );

  return <PrerequisiteChecklist caseId={c.id} prerequisites={prerequisites} />;
};
